// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"f2a7d1e0","977":"d123378c"}[chunkId] + ".chunk.js";
};